export const createFeedFormData = ({ userId, title = "", description, category, images = [] }) => {
  if (!userId) throw new Error("Please sign in before posting.");
  if (!description?.trim()) throw new Error("Please write something before posting.");
  if (!["Announcements", "Introductions", "Questions", "Requests"].includes(category)) {
    throw new Error("Please choose a post category.");
  }
  const payload = new FormData();
  payload.append("user_id", String(userId));
  if (title.trim()) payload.append("title", title.trim());
  payload.append("description", description.trim());
  payload.append("category", category);
  images.forEach((file) => payload.append("images", file));
  return payload;
};

export const normalizeFeed = (feed) => {
  const date = new Date(feed.created_at);
  const elapsed = Math.max(0, Date.now() - date.getTime());
  let time = "";
  if (Number.isFinite(elapsed)) {
    const minutes = Math.floor(elapsed / 60000);
    const hours = Math.floor(minutes / 60);
    time = minutes < 1 ? "Just now" : minutes < 60 ? `${minutes} min${minutes === 1 ? "" : "s"} ago`
      : hours < 24 ? `${hours} hour${hours === 1 ? "" : "s"} ago` : date.toLocaleDateString();
  }
  const avatar = Array.isArray(feed.user_profile_image) ? feed.user_profile_image.find(Boolean) : feed.user_profile_image;
  return {
    id: String(feed.id), userId: feed.user_id, title: feed.title || "",
    text: feed.description || "", category: feed.category || "",
    author: feed.user_name || "Pack member", avatar: typeof avatar === "string" ? avatar : null,
    images: Array.isArray(feed.images) ? feed.images.filter((url) => typeof url === "string" && url) : [],
    likes: Math.max(0, Number(feed.treat_count) || 0),
    commentCount: Math.max(0, Number(feed.comment_count) || 0), comments: [],
    createdAt: feed.created_at, updatedAt: feed.updated_at, time,
  };
};
